import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "type-bus-form flex-col flex relative h-full overflow-x-hidden",
  style: {"overflow-y":"auto"}
}
const _hoisted_2 = { class: "title-form py-5 mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-lg px-4 py-4 background-orange-lighten-5 mx-2 mb-4"
}
const _hoisted_5 = { class: "font-bold color-primary mb-1" }
const _hoisted_6 = { class: "flex w-full justify-between" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "color-primary" }, /*#__PURE__*/_toDisplayString('Total Klaim Saat Ini'), -1)
const _hoisted_8 = { class: "font-bold color-primary" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-field mb-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "KategoriKlaimId" }, "Kategori Klaim", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { class: "p-field mb-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "nominalId" }, "Nominal", -1)
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = {
  key: 1,
  class: "p-error"
}
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "descId" }, "Keterangan", -1)
const _hoisted_19 = { class: "btn-action w-full mt-auto mb-5" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h6", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.dataEdit)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.dataEdit.NamaAgen), 1),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("p", _hoisted_8, "Rp. " + _toDisplayString(new Number(_ctx.dataEdit.Total).toLocaleString("id-ID")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("form", {
      class: "flex-col flex h-full mx-3",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_Dropdown, {
            id: "KategoriKlaimId",
            modelValue: _ctx.v$.kategoriKlaimId.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.kategoriKlaimId.$model = $event)),
            filter: true,
            options: _ctx.listKategori,
            class: "mt-1 input-primary",
            optionLabel: "Nama",
            optionValue: "Id",
            placeholder: "Pilih kategori klaim"
          }, null, 8, ["modelValue", "options"]),
          ((_ctx.v$.kategoriKlaimId.$invalid && _ctx.submitted) || _ctx.v$.kategoriKlaimId.$pending.$response)
            ? (_openBlock(), _createBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.kategoriKlaimId.required.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_InputNumber, {
            id: "additionalCostId",
            class: "input-primary rounded-lg w-full mt-1",
            modelValue: _ctx.v$.nominal.$model,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.nominal.$model = $event)),
            mode: "currency",
            currency: "IDR",
            currencyDisplay: "code",
            locale: "id-ID"
          }, null, 8, ["modelValue"]),
          ((_ctx.v$.nominal.required.$invalid && _ctx.submitted))
            ? (_openBlock(), _createBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.nominal.required.$message), 1))
            : _createCommentVNode("", true),
          ((_ctx.v$.nominal.minValue.$invalid && _ctx.submitted))
            ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.v$.nominal.minValue.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_Textarea, {
            id: "descId",
            class: "input-primary mt-1",
            type: "text",
            modelValue: _ctx.dataForm.keterangan,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataForm.keterangan = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_Button, {
          label: "Simpan",
          class: "font-semibold p-button-sm btn-primary px-10 mr-2",
          type: "submit"
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black p-button-sm px-10 py-1",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeSidebar()))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ], 32)
  ]))
}